<template>
  <div class="box-table-sale" :class="subIndentClass">
    <vxe-grid
      ref="refTableSale"
      class="table-sale"
      :min-height="tableConfig.minHeight"
      :show-footer="!parent"
      :toolbar-config="tableConfig.toolbarConfig"
      :row-config="{ isCurrent: false }"
      :mouse-config="tableConfig.mouseConfig"
      :columns="tableColumn"
      :data="selfData"
      :footer-method="footerMethod"
      @edit-activated="cellEditActivated"
      @edit-closed="cellEditClosed"
    >
      <!-- 表格按钮位置 -->
      <template #buttons>
        <div
          v-if="tableTitleArr.length > 1"
          class="table-title is-toggle"
          title="点击收起下级"
          @click="toggleSelf"
        >
          <i class="el-icon-caret-bottom table-title__icon"></i>
          <span class="table-title__no">{{ tableSeqPrefix }}<span class="table-title__last">{{ tableSeqLast }}</span></span>
          <span class="table-title__seq">({{ tableLevelText }})</span>
          <span v-for="(item, index) in tableTitleArr.slice(1)" :key="index">
            <span :class="item.isActive ? 'c-green' : ''">{{ item.name }}</span>
            <span v-if="!item.isActive && item.name" class="m-x-2">&gt;</span>
          </span>
        </div>
        <div v-else class="table-title">
          <span class="c-green">销售清单</span>
        </div>
      </template>

      <!-- 序号 -->
      <template #default_seq="{ row, rowIndex }">
        <div class="flex flex-center">
          <span v-if="row.is_xie_tong" class="iconfont icon-xiezuo c-blue f-s-24 m-l-5"></span>
          <span v-else>{{ rowIndex + 1 }}</span>
        </div>
      </template>

      <!-- 商品图片 -->
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image v-if="row.list_chan_pin_tu" :list.sync="row.list_chan_pin_tu" disabled />
      </template>

      <!-- 商品名称 -->
      <template #default_name="{ row, rowIndex }">
        <div class="flex flex-y-center">
          <!-- bom 父子层级：行内展开/收起 -->
          <span
            v-if="row.tableBomData.length"
            class="bom-toggle"
            :title="row.isShow === false ? '展开下级' : '收起下级'"
            @click="bomToggle(row)"
          >
            <i :class="row.isShow === false ? 'el-icon-caret-right' : 'el-icon-caret-bottom'"></i>
          </span>
          <el-link class="m-l-5" type="primary" @click="openPopupVerifyGoodsEdit(rowIndex)">
            {{ row.name }}
          </el-link>
        </div>
      </template>

      <!-- 每套数量 -->
      <template #default_counts_unit="{ row }">
        <div class="flex flex-center">
          <span>{{ row.counts_unit }}</span>
          <span v-if="row.counts_unit && row.counts">(共{{ row.counts }})</span>
        </div>
      </template>

      <!-- 销售金额 -->
      <template #default_sales_amount="{ row }">
        {{ !parent || Number(row.sales_price) ? row.sales_amount : '' }}
      </template>

      <!-- 每件利润 -->
      <template #default_profit_row_unit="{ row }">
        {{ !parent || Number(row.sales_price) ? row.profit_row_unit : '' }}
      </template>

      <!-- 合计利润 -->
      <template #default_profit_row="{ row }">
        {{ !parent || Number(row.sales_price) ? row.profit_row : '' }}
      </template>

      <!-- 利润率 -->
      <template #default_profit_rate="{ row }">
        {{ !parent || Number(row.sales_price) ? row.profit_rate : '' }}
      </template>

      <!-- 备注 -->
      <template #default_remark="{ row }">
        {{ row.remark || '-' }}
      </template>
    </vxe-grid>

    <!-- bom表 递归 -->
    <template v-for="(item, index) in selfData">
      <TableSale
        v-if="item.tableBomData.length && item.isShow !== false"
        :key="index"
        :tableTitle="`${tableTitle}>${item.name}`"
        :tableSeq="`${tableSeq ? tableSeq + '-' : ''}${index + 1}`"
        :parent="item"
        :data.sync="item.tableBomData"
        disabled
        :statusName="statusName"
      />
    </template>

    <!-- 弹窗-编辑 -->
    <b-popup-verify-goods-edit
      v-if="isShowPopupVerifyGoodsEdit"
      :show.sync="isShowPopupVerifyGoodsEdit"
      :data.sync="selfData[activeIndex]"
      disabled
    />
  </div>
</template>

<script>
export default {
  name: 'TableSale',
  props: {
    tableTitle: {
      type: String,
      required: true
    },
    // bom 清单序号组合，如 2-1（父行序号-子行序号）
    tableSeq: {
      type: String,
      default: ''
    },
    parent: {
      type: Object,
      default: () => {
        return null
      }
    },
    data: {
      type: Array,
      required: true
    },
    statusName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rowIndex: null,
      columnIndex: null,

      selfData: [],
      isShowPopupVerifyGoodsEdit: false, // 编辑
      activeIndex: null // 当前行索引
    }
  },
  provide() {
    return {
      inject_tableSale: () => {
        return this.selfData[this.activeIndex]
      }
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let obj = {
        toolbarConfig: {
          enabled: true,
          slots: {
            buttons: 'buttons'
          }
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    // 是否子级表格（存在 bom 父级）
    isSubTable() {
      return this.tableTitleArr.length > 1
    },
    // 子级表格缩进：39px（排序列 40px 减 1px 边框补偿），子表排序列表对齐父表序号列
    subIndentClass() {
      return this.isSubTable ? 'is-sub' : ''
    },
    // 表格标题
    tableTitleArr() {
      let arr = this.tableTitle.split('>')
      let result = arr.map((item, index) => {
        return {
          name: item,
          isActive: index === arr.length - 1
        }
      })
      return result
    },
    // 序号组合前缀（如 1-1-），与最后一段分开配色
    tableSeqPrefix() {
      let arr = this.tableSeq.split('-')
      arr.pop()
      return arr.length ? `${arr.join('-')}-` : ''
    },
    // 序号组合最后一段（如 2），红色高亮
    tableSeqLast() {
      let arr = this.tableSeq.split('-')
      return arr[arr.length - 1] || ''
    },
    // bom 层级数（第 1 层为 1 级，依此类推）
    tableLevel() {
      return this.tableSeq ? this.tableSeq.split('-').length : 0
    },
    // bom 层级中文描述，如 一级bom表 / 二级bom表
    tableLevelText() {
      let arr = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      return `${arr[this.tableLevel - 1] || this.tableLevel}级bom表`
    },
    tableColumn() {
      let result = []
      let arrStart = [
        {
          fixed: 'left',
          title: '序号',
          width: 40,
          slots: { default: 'default_seq' }
        },
        {
          title: '商品图片',
          width: 63,
          slots: { default: 'default_list_chan_pin_tu' }
        },
        {
          title: '商品名称',
          width: 158,
          slots: { default: 'default_name' }
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 100
        },
        {
          title: '单位',
          field: 'unit',
          width: 80
        }
      ]
      let arrCenter = []
      let arrTop = [
        {
          title: '数量',
          field: 'counts',
          width: 80
        },
        {
          title: '单价',
          field: 'goods_price',
          width: 80
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        {
          title: '销售单价',
          field: 'sales_price',
          width: 80
        },
        {
          title: '销售金额',
          field: 'sales_amount',
          slots: { default: 'default_sales_amount' }
        },
        {
          title: '每件利润',
          field: 'profit_row_unit',
          slots: { default: 'default_profit_row_unit' }
        },
        {
          title: '合计利润',
          field: 'profit_row',
          slots: { default: 'default_profit_row' }
        },
        {
          title: '利润率(%)',
          field: 'profit_rate',
          width: 80,
          slots: { default: 'default_profit_rate' }
        }
      ]
      let arrBom = [
        {
          title: '每套数量',
          width: 80,
          slots: { default: 'default_counts_unit' }
        },
        {
          title: '单价',
          field: 'goods_price',
          width: 80
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        {
          title: '',
          minWidth: 20
        }
      ]
      let arrEnd = [
        {
          title: '备注',
          slots: { default: 'default_remark' },
          width: 132
        }
      ]
      arrCenter = !this.parent ? arrTop : arrBom
      result = [...arrStart, ...arrCenter, ...arrEnd]
      return result
    }
  },
  watch: {
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
          if (this.rowIndex !== null && this.columnIndex !== null) {
            this.$refs.refTableSale.setEditCell(
              this.selfData[this.rowIndex],
              this.tableColumn[this.columnIndex].field
            )
          }
        }
      },
      deep: true,
      immediate: true
    },
    selfData: {
      handler(val) {
        if (JSON.stringify(this.data) !== JSON.stringify(val)) {
          this.$emit('update:data', this.$util.deepCopy(val))
        }
      },
      deep: true
    }
  },
  methods: {
    // 单元格-编辑选中
    cellEditActivated(data) {
      this.rowIndex = data.rowIndex
      this.columnIndex = data.columnIndex
    },
    // 单元格-编辑关闭
    cellEditClosed() {
      this.rowIndex = null
      this.columnIndex = null
    },
    // 获取-当前选中记录
    getCurrentRecord() {
      return this.$refs.refTableSale.getCurrentRecord()
    },
    // 获取-当前选中记录索引
    getRowIndex(row) {
      return this.$refs.refTableSale.getRowIndex(row)
    },
    // bom-展开收起切换
    bomToggle(row) {
      let isShow = row.isShow !== false // 当前是否展开
      this.$set(row, 'isShow', !isShow)
    },
    // 子级表格-点击标题收起（展开由父行箭头控制）
    toggleSelf() {
      if (!this.parent) return
      this.$set(this.parent, 'isShow', false)
    },
    // 编辑
    openPopupVerifyGoodsEdit(index) {
      this.activeIndex = index
      this.isShowPopupVerifyGoodsEdit = true
    },
    // 表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (
            [
              'counts',
              'goods_price',
              'goods_amount',
              'sales_amount',
              'sales_price',
              'profit_row_unit',
              'profit_row'
            ].includes(column.field)
          ) {
            return this.$util.listFieldTotal(data, column.field)
          }
          if (['profit_rate'].includes(column.field)) {
            return this.$util.listFieldAverage(data, column.field)
          }
        })
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.box-table-sale {
  position: relative;
  box-sizing: border-box;
  width: 1378px;
  // 子级表格：左缩进 39px（排序列 40px 减 1px 边框补偿），使子表排序列表对齐父表序号列；宽度自动收窄，右边缘始终与父表对齐
  &.is-sub {
    width: auto;
    margin-left: 39px;
  }
  // 子级表格：缩进量由 margin-left 表达，不再画引导线
  .table-title {
    padding: 3px 0;
    font-size: 14px;
    color: #000;
    font-weight: bold;
    &.is-toggle {
      cursor: pointer;
      user-select: none;
      &:hover {
        color: #67c33a;
      }
    }
        .table-title__no {
          color: #000;
          font-weight: bold;
        }
        .table-title__last {
          color: #f56c6c;
        }
        .table-title__seq {
          margin-left: 0;
          margin-right: 8px;
          color: #909399;
          font-size: 13px;
          font-weight: normal;
        }
    .table-title__icon {
      margin-right: 2px;
      color: #67c33a;
      vertical-align: middle;
    }
  }
  // 行内 bom 展开/收起箭头
  .bom-toggle {
    flex: none;
    padding: 0 2px;
    color: #67c33a;
    cursor: pointer;
    line-height: 1;
    i {
      font-size: 14px;
      vertical-align: middle;
    }
  }
  .table-sale {
    margin: -1px;
  }
  /deep/ .vxe-grid--toolbar-wrapper {
    padding: 0 5px;
    border: 1px solid #e8eaec;
    border-bottom: none;
  }
  /deep/ .vxe-cell--valid-error-hint {
    display: none;
  }
  /deep/ .vxe-table--render-default .vxe-header--column.bg-green {
    background-color: #67c33a;
    color: #fff;
  }
  /deep/ .vxe-table--render-default.vxe-editable .vxe-body--column.bg-green {
    background-color: #f0f9eb;
  }
  /deep/ .vxe-table--render-default.vxe-editable .vxe-body--column.bg-blue {
    background-color: #c6e2ff;
  }
  /deep/ .vxe-toolbar {
    padding: 5px 0;
  }
}
</style>
